import { render, staticRenderFns } from "./DocList.vue?vue&type=template&id=07214fe1&scoped=true"
import script from "./DocList.vue?vue&type=script&lang=js"
export * from "./DocList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07214fe1",
  null
  
)

export default component.exports